import { init } from "@instantdb/react";
import { instantDbAppId } from "../../constants.ts";
import schema from "../../instant.schema.ts";

export const db = init({ appId: instantDbAppId, schema });
